<template>
  <AllegroJsonForm
    title="Allegro - Dodaj nadawcę"
    crumbLabel="Dodaj nadawcę"
    :settingsCrumb="true"
    submitAction="createAllegroSender"
    submitGetter="getAllegroSenderCreateData"
    backRoute="/allegro/accounts"
    accountPkParam="pk"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroSenderPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroSenderCreate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroSenderPermissionsConst.add,
      fields: [
        { key: "company_name", label: "Nazwa firmy", required: true },
        { key: "name", label: "Imię i Nazwisko", required: true },
        { key: "street", label: "Ulica", required: true },
        { key: "zip_code", label: "Kod pocztowy", required: true },
        { key: "city", label: "Miejscowość", required: true },
        { key: "country_code", label: "Kod kraju", required: true },
        { key: "email", label: "E-mail", type: "email", required: true },
        { key: "phone", label: "Nr telefonu", required: true },
      ],
    };
  },
};
</script>
